module.exports = __webpack_public_path__ + "static/media/none-user-avatar.aacd3b89.png";